query getDailyStakes($eth_address: String!) {
    getDailyStakes(eth_address: $eth_address)
}